import { createTranslations } from '@npco/utils-translations'

export const accountBalanceChartTranslations = createTranslations({
  timeZoneWarning: 'Note: This graph is based on Sydney / Melbourne time.',
})
